// extracted by mini-css-extract-plugin
export default {"grupobtnav":"Footer_grupobtnav__huAlO","areanavfooter":"Footer_areanavfooter__D1VeQ","imgadelante":"Footer_imgadelante__ww7jK","btningresar":"Footer_btningresar__R2npD"};